if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 * 在庫ステータスをリアルタイムで同期
 * ページ読み込み時とバリエーション変更時に最新在庫を取得
 */
(function() {
  function updateProductInventory() {
    const productForm = document.querySelector('product-form');
    if (!productForm) return;

    const variantIdInput = productForm.querySelector('[name="id"]');
    if (!variantIdInput) return;
    const currentVariantId = variantIdInput.value;

    const pathParts = window.location.pathname.split('/');
    const productIndex = pathParts.indexOf('products');
    const productHandle = pathParts[productIndex + 1];
    if (!productHandle) return;

    // キャッシュ回避
    const cacheBuster = new Date().getTime();

    fetch(`/products/${productHandle}.js?v=${cacheBuster}`)
      .then(response => response.json())
      .then(product => {
        const currentVariant = product.variants.find(v => v.id == currentVariantId);
        const submitButton = productForm.querySelector('[type="submit"]');
        if (!submitButton || !currentVariant) return;

        const buttonText = submitButton.querySelector('span:not(.sold-out-message)');
        const soldOutMessage = submitButton.querySelector('.sold-out-message');

        if (currentVariant.available) {
          // 在庫あり
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('disabled');
          if (buttonText) buttonText.classList.remove('hidden');
          if (soldOutMessage) soldOutMessage.classList.add('hidden');
        } else {
          // 在庫なし
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('disabled');
          if (buttonText) buttonText.classList.add('hidden');
          if (soldOutMessage) soldOutMessage.classList.remove('hidden');
        }
      })
      .catch(error => console.error('在庫同期エラー:', error));
  }

  // ページ読み込み時
  document.addEventListener('DOMContentLoaded', updateProductInventory);

  // URL変更監視(バリエーション切り替え対応)
  let lastUrl = location.href;
  const observer = new MutationObserver(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateProductInventory, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
